import React from 'react'
import styled from 'styled-components'

const Button = styled.button
`
background-color: black;
color : #64ffd3;
padding : 5px 15px;
box-shadow: 0px 2px 2px #64ffd3;
margin-left: 2%;
border-color : #64ffd3;
cursor: pointer;
`

export default Button
